import { ROLES } from "./roles";

const getMenuItems = (t, userRole) => [
  {
    name: t("aside-menu-item-dishes"),
    linkForRoute: "dishes",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1024 1024"
        fill="currentColor"
      >
        <path d="M480 257.152V192h-96a32 32 0 0 1 0-64h256a32 32 0 1 1 0 64h-96v65.152A448 448 0 0 1 955.52 768H68.48A448 448 0 0 1 480 257.152zM128 704h768a384 384 0 1 0-768 0zM96 832h832a32 32 0 1 1 0 64H96a32 32 0 1 1 0-64z" />
      </svg>
    ),
    allowedRoles:
      userRole?.includes(ROLES.ADMIN) ||
      userRole?.includes(ROLES.MANAGER) ||
      userRole?.includes(ROLES.NUTRITIONIST)
        ? true
        : false,
  },
  {
    name: t("aside-menu-item-menu"),
    linkForRoute: "menu",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1024 1024"
        fill="currentColor"
      >
        <path d="M480 320h192c21.33 0 32-10.67 32-32s-10.67-32-32-32H480c-21.33 0-32 10.67-32 32s10.67 32 32 32z" />
        <path
          fill="currentColor"
          d="M887.01 72.99C881.01 67 873.34 64 864 64H160c-9.35 0-17.02 3-23.01 8.99C131 78.99 128 86.66 128 96v832c0 9.35 2.99 17.02 8.99 23.01S150.66 960 160 960h704c9.35 0 17.02-2.99 23.01-8.99S896 937.34 896 928V96c0-9.35-3-17.02-8.99-23.01zM192 896V128h96v768h-96zm640 0H352V128h480v768z"
        />
      </svg>
    ),
    allowedRoles:
      userRole?.includes(ROLES.ADMIN) ||
      userRole?.includes(ROLES.MANAGER) ||
      userRole?.includes(ROLES.NUTRITIONIST)
        ? true
        : false,
  },
  {
    name: t("aside-menu-item-orders"),
    linkForRoute: "orders",
    icon: (
      <svg
        data-v-0b661339=""
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1024 1024"
      >
        <path
          fill="currentColor"
          d="M128 384v448h768V384H128zm-32-64h832a32 32 0 0 1 32 32v512a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V352a32 32 0 0 1 32-32zm64-128h704v64H160zm96-128h512v64H256z"
        ></path>
      </svg>
    ),
    allowedRoles:
      userRole?.includes(ROLES.ADMIN) || userRole?.includes(ROLES.MANAGER)
        ? true
        : false,
  },
  {
    name: t("aside-menu-item-clients"),
    linkForRoute: "clients",
    icon: (
      <svg
        data-v-0b661339=""
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1024 1024"
      >
        <path
          fill="currentColor"
          d="M512 512a192 192 0 1 0 0-384 192 192 0 0 0 0 384zm0 64a256 256 0 1 1 0-512 256 256 0 0 1 0 512zm320 320v-96a96 96 0 0 0-96-96H288a96 96 0 0 0-96 96v96a32 32 0 1 1-64 0v-96a160 160 0 0 1 160-160h448a160 160 0 0 1 160 160v96a32 32 0 1 1-64 0z"
        ></path>
      </svg>
    ),
    allowedRoles:
      userRole?.includes(ROLES.ADMIN) || userRole?.includes(ROLES.MANAGER)
        ? true
        : false,
  },
  {
    name: t("aside-menu-item-statistics"),
    linkForRoute: "statistics",
    icon: (
      <svg
        data-v-0b661339=""
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1024 1024"
      >
        <path
          fill="currentColor"
          d="m665.216 768 110.848 192h-73.856L591.36 768H433.024L322.176 960H248.32l110.848-192H160a32 32 0 0 1-32-32V192H64a32 32 0 0 1 0-64h896a32 32 0 1 1 0 64h-64v544a32 32 0 0 1-32 32H665.216zM832 192H192v512h640V192zM352 448a32 32 0 0 1 32 32v64a32 32 0 0 1-64 0v-64a32 32 0 0 1 32-32zm160-64a32 32 0 0 1 32 32v128a32 32 0 0 1-64 0V416a32 32 0 0 1 32-32zm160-64a32 32 0 0 1 32 32v192a32 32 0 1 1-64 0V352a32 32 0 0 1 32-32z"
        ></path>
      </svg>
    ),
    allowedRoles:
      userRole?.includes(ROLES.ADMIN) || userRole?.includes(ROLES.MANAGER)
        ? true
        : false,
  },
  {
    name: t("aside-menu-item-messages"),
    linkForRoute: "messages",
    icon: (
      <svg
        data-v-0b661339=""
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1024 1024"
      >
        <path
          fill="currentColor"
          d="M128 224v512a64 64 0 0 0 64 64h640a64 64 0 0 0 64-64V224H128zm0-64h768a64 64 0 0 1 64 64v512a128 128 0 0 1-128 128H192A128 128 0 0 1 64 736V224a64 64 0 0 1 64-64z"
        ></path>
        <path
          fill="currentColor"
          d="M904 224 656.512 506.88a192 192 0 0 1-289.024 0L120 224h784zm-698.944 0 210.56 240.704a128 128 0 0 0 192.704 0L818.944 224H205.056z"
        ></path>
      </svg>
    ),
    allowedRoles:
      userRole?.includes(ROLES.ADMIN) || userRole?.includes(ROLES.MANAGER)
        ? true
        : false,
  },
  {
    name: t("aside-menu-item-storage"),
    linkForRoute: "storage",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1024 1024"
        fill="currentColor"
      >
        <path d="M64 160h896v128H64zm64 192h768v512H128zm192 128v64h384v-64H320zm0 128v64h384v-64H320z" />
      </svg>
    ),
    allowedRoles:
      userRole?.includes(ROLES.ADMIN) || userRole?.includes(ROLES.MANAGER)
        ? true
        : false,
  },
  {
    name: t("aside-menu-item-builder"),
    linkForRoute: "builder",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1024 1024"
        fill="currentColor"
      >
        <path d="M864 64H160a96 96 0 0 0-96 96v704a96 96 0 0 0 96 96h704a96 96 0 0 0 96-96V160a96 96 0 0 0-96-96zm32 800a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32h704a32 32 0 0 1 32 32v704zM288 416h448a32 32 0 0 0 0-64H288a32 32 0 0 0 0 64zm0 192h448a32 32 0 0 0 0-64H288a32 32 0 0 0 0 64zm0 192h256a32 32 0 0 0 0-64H288a32 32 0 0 0 0 64z" />
      </svg>
    ),
    allowedRoles: userRole?.includes(ROLES.ADMIN) ? true : false,
  },
  {
    name: t("aside-menu-item-settings"),
    linkForRoute: "settings",
    icon: (
      <svg
        data-v-0b661339=""
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1024 1024"
      >
        <path
          fill="currentColor"
          d="M224 160a64 64 0 0 0-64 64v576a64 64 0 0 0 64 64h576a64 64 0 0 0 64-64V224a64 64 0 0 0-64-64H224zm0-64h576a128 128 0 0 1 128 128v576a128 128 0 0 1-128 128H224A128 128 0 0 1 96 800V224A128 128 0 0 1 224 96z"
        ></path>
        <path
          fill="currentColor"
          d="M384 416a64 64 0 1 0 0-128 64 64 0 0 0 0 128zm0 64a128 128 0 1 1 0-256 128 128 0 0 1 0 256z"
        ></path>
        <path
          fill="currentColor"
          d="M480 320h256q32 0 32 32t-32 32H480q-32 0-32-32t32-32zm160 416a64 64 0 1 0 0-128 64 64 0 0 0 0 128zm0 64a128 128 0 1 1 0-256 128 128 0 0 1 0 256z"
        ></path>
        <path
          fill="currentColor"
          d="M288 640h256q32 0 32 32t-32 32H288q-32 0-32-32t32-32z"
        ></path>
      </svg>
    ),
    allowedRoles:
      userRole?.includes(ROLES.ADMIN) ||
      userRole?.includes(ROLES.MANAGER) ||
      userRole?.includes(ROLES.NUTRITIONIST)
        ? true
        : false,
  },
];

export { getMenuItems };

